import * as yup from "yup";

import { Shape } from "@/core/yup";
import { AddressMaxLength } from "@/validations/address";

import { ChangeAddressFormType } from "./formType";

export const formSchema = () =>
    yup.object<{}, Shape<ChangeAddressFormType>>({
        mainAddress: yup.string().max(AddressMaxLength.Street).required(),
        additionalAddress: yup.string().max(AddressMaxLength.AdditionalAddress),
        number: yup.string().max(AddressMaxLength.HouseNumber).required(),
        mailBox: yup.string().max(AddressMaxLength.MailBox),
        postCode: yup.string().max(AddressMaxLength.ZipCode).required(),
        city: yup.string().max(AddressMaxLength.City).required(),
        country: yup.string().required(),
        activationDate: yup.date().nullable().required(),
    });
